import React from "react";
import { motion } from "framer-motion";
import SEO from "@/components/SEO";
import { COMPANY, LEGAL } from "@/data";

const MentionsLegales = () => (
  <>
    <SEO
      title="Mentions Légales"
      description="Mentions légales de VistaWash. Detailing automobile à Châtelet, Belgique. Coordonnées, hébergeur, numéro d'entreprise."
      path="/mentions-legales"
    />

    <section className="pt-40 pb-16 px-6 md:px-12">
      <div className="max-w-4xl mx-auto">
        <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
          <span className="text-[11px] uppercase tracking-[0.3em] text-[#D90000]">— Informations légales</span>
          <h1 className="font-impact text-5xl md:text-7xl lg:text-8xl leading-[0.9] mt-6">
            MENTIONS <br />
            <span className="text-[#D90000]">LÉGALES.</span>
          </h1>
        </motion.div>
      </div>
    </section>

    <section className="pb-32 px-6 md:px-12">
      <div className="max-w-4xl mx-auto space-y-16">
        <LegalBlock number="01" title="Éditeur du site">
          <p><strong className="text-white">Dénomination :</strong> {LEGAL.legal_name}</p>
          <p><strong className="text-white">Forme juridique :</strong> {LEGAL.legal_form}</p>
          <p><strong className="text-white">Siège social :</strong> {COMPANY.address_line1}, {COMPANY.address_line2}</p>
          <p><strong className="text-white">Numéro BCE :</strong> {LEGAL.bce}</p>
          <p><strong className="text-white">TVA :</strong> {LEGAL.tva}</p>
          <p><strong className="text-white">Téléphone :</strong> <a href={COMPANY.phone_link} className="text-[#D90000] hover:underline">{COMPANY.phone_display}</a></p>
          <p><strong className="text-white">Email :</strong> <a href={`mailto:${COMPANY.email}`} className="text-[#D90000] hover:underline">{COMPANY.email}</a></p>
        </LegalBlock>

        <LegalBlock number="02" title="Directeur de la publication">
          <p>{LEGAL.publication_director}, gérant de VistaWash.</p>
        </LegalBlock>

        <LegalBlock number="03" title="Hébergement du site">
          <p><strong className="text-white">Hébergeur :</strong> Emergent Labs</p>
          <p><strong className="text-white">Site web :</strong> <a href="https://emergent.sh" target="_blank" rel="noopener noreferrer" className="text-[#D90000] hover:underline">emergent.sh</a></p>
        </LegalBlock>

        <LegalBlock number="04" title="Propriété intellectuelle">
          <p>
            L'ensemble du contenu de ce site (textes, images, vidéos, logos, graphismes, code source) est la propriété exclusive de VistaWash, sauf mention contraire. Toute reproduction, représentation, modification, publication ou adaptation, totale ou partielle, sans autorisation écrite préalable est strictement interdite et constitue une contrefaçon sanctionnée par les articles L.335-2 et suivants du Code de la propriété intellectuelle.
          </p>
        </LegalBlock>

        <LegalBlock number="05" title="Responsabilité">
          <p>
            VistaWash s'efforce de fournir des informations exactes et à jour. Cependant, VistaWash ne peut garantir l'exactitude, la complétude ou l'actualité des informations diffusées sur le site. La responsabilité de VistaWash ne saurait être engagée en cas d'erreur, d'omission ou d'indisponibilité des informations.
          </p>
        </LegalBlock>

        <LegalBlock number="06" title="Droit applicable & juridiction">
          <p>
            Le présent site et ses conditions d'utilisation sont régis par le droit belge. Tout litige relatif à l'utilisation du site sera soumis à la compétence exclusive des tribunaux de Charleroi, Belgique.
          </p>
        </LegalBlock>

        <LegalBlock number="07" title="Contact">
          <p>
            Pour toute question relative aux présentes mentions légales, vous pouvez nous contacter à : <a href={`mailto:${COMPANY.email}`} className="text-[#D90000] hover:underline">{COMPANY.email}</a>
          </p>
        </LegalBlock>
      </div>
    </section>
  </>
);

const LegalBlock = ({ number, title, children }) => (
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.7 }}
    data-testid={`legal-block-${number}`}
    className="border-l-2 border-[#D90000] pl-8"
  >
    <div className="flex items-baseline gap-4 mb-6">
      <span className="font-impact text-2xl text-[#D90000]">{number}</span>
      <h2 className="font-impact text-2xl md:text-3xl uppercase tracking-wide">{title}</h2>
    </div>
    <div className="space-y-3 text-white/70 leading-relaxed">
      {children}
    </div>
  </motion.div>
);

export default MentionsLegales;
